import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForUrlAliasComponent extends Component {
  // Defaults
  defaultColumns = [
    'id',
    'name',
    'artist',
    'parent',
    'cmsState',
    'cmsModified',
  ];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'name',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'artist',
      type: 'relation',
    },
    {
      property: 'parent',
      type: 'relation',
    },
    {
      property: 'cmsState',
      sortable: true,
      type: 'translate-value',
      align: 'right',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
